import React from "react";
import { CareCommentAnalysisDataTableBody } from "./CareCommentAnalysisDataTableBody";
import { CareCommentAnalysisDataTableHead } from "./CareCommentAnalysisDataTableHead";

export const CareCommentAnalysisDataTable = React.memo(function CareCommentAnalysisDataTable() {
    return (
        <table>
            <CareCommentAnalysisDataTableHead />
            <CareCommentAnalysisDataTableBody />
        </table>
    );
});
